import { atom } from "recoil";
export const clientIdAtom = atom({
  key: "clientIdAtom", // unique ID (with respect to other atoms/selectors)
  default: 0, // default value (aka initial value)
});
